import { CarSearch, CarSearchSchema } from "@models/car";
import { createBrowseUrlParams, DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD, ParsedBrowseUrl } from "@features/tickets/shared/utils/browseUrlParams";

export { DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD };
export type ParsedCarsUrl = ParsedBrowseUrl<CarSearch>;

const carsBrowseUrl = createBrowseUrlParams<CarSearch>(CarSearchSchema);

export const parseCarsUrlParams = carsBrowseUrl.parseBrowseUrlParams;
export const syncCarsUrlParams = carsBrowseUrl.syncBrowseUrlParams;
